import ImageOptimize from '@/components/ImageOptimize'
import { PageTypeSuffix } from '@/constants'

import { useNotification, useStore } from '@/containers'
import { getTranslate } from '@/utils/api-interceptors'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import Link from 'next/link'

const ChooseProductCompare = dynamic(
  () => import('../components/Popup/ChooseProductCompare'),
  {
    ssr: false,
  }
)

const ComparePopup = dynamic(() => import('../components/Popup/ComparePopup'), {
  ssr: false,
})

const CompareTinyPopup = dynamic(
  () => import('../components/Popup/CompareTinyPopup'),
  {
    ssr: false,
  }
)

const OnDevelopPopup = dynamic(
  () => import('../components/Popup/OnDevelopPopup'),
  {
    ssr: false,
  }
)
type FooterProps = {
  page?: string
}
const Footer = ({ page }: FooterProps) => {
  const {
    bottomMenu,
    isOpenComingSoon,
    setIsOpenComingSoon,
    isOpenAddComparePopup,
    setProductCompares,
    productCompares,
    setIsOpenAddComparePopup,
    isOpenComparePopup,
    setIsOpenComparePopup,
    productViewed,
    catViewId,
  } = useStore()
  const { systemConfig } = useNotification()

  const t = useTranslations('Footer')
  return (
    <footer id='footer' className='w-full bg-transparent'>
      {page === 'product-detail' && (
        <>
          <ComparePopup
            open={isOpenComparePopup}
            setIsOpenComparePopup={setIsOpenComparePopup}
            setProductCompares={setProductCompares}
            setIsOpenAddComparePopup={setIsOpenAddComparePopup}
            productCompares={productCompares}
          />

          <ChooseProductCompare
            catViewId={catViewId}
            productViewed={productViewed}
            isOpen={isOpenAddComparePopup}
            setProductCompares={setProductCompares}
            productCompares={productCompares}
            setIsOpen={setIsOpenAddComparePopup}
          />

          <CompareTinyPopup
            isOpen={!isOpenComparePopup}
            productCompares={productCompares.filter(e => e._id).length}
            setIsOpen={setIsOpenComparePopup}
          />
        </>
      )}

      <OnDevelopPopup
        isOpen={isOpenComingSoon}
        setIsOpen={setIsOpenComingSoon}
      />

      <section className='bg-primary pb-8 pt-9 text-white'>
        <div className='container mx-auto flex justify-between'>
          <div className='flex max-w-[25%] flex-4 flex-col gap-3'>
            <h5 className='text-lg font-semibold'>KẾT NỐI SHOP1</h5>

            <div className='flex gap-2'>
              {!!systemConfig?.companyFacebook && (
                <Link href={systemConfig.companyFacebook} target='blank'>
                  <img
                    src='/assets/icons/fb.svg'
                    alt='Facebook'
                    className='h-5 w-5'
                  />
                </Link>
              )}
              {!!systemConfig?.companyYoutube && (
                <Link href={systemConfig.companyYoutube} target='blank'>
                  <img
                    src='/assets/icons/yt.svg'
                    alt='Youtube'
                    className='h-5 w-5'
                  />
                </Link>
              )}
              {!!systemConfig?.companyInstagram && (
                <Link href={systemConfig.companyInstagram} target='blank'>
                  <img
                    src='/assets/icons/ig.svg'
                    alt='Instagram'
                    className='h-5 w-5'
                  />
                </Link>
              )}
              {!!systemConfig?.companyTikTok && (
                <Link href={systemConfig.companyTikTok} target='blank'>
                  <img
                    src='/assets/icons/tk.svg'
                    alt='Tiktok'
                    className='h-5 w-5'
                  />
                </Link>
              )}
            </div>

            {systemConfig?.companyPhone && (
              <div>
                <p className='text-sm'>{systemConfig?.companyLabelPhone}</p>
                <p className='mt-1 text-lg font-semibold'>
                  <a href={`tel:${systemConfig?.companyPhone}`}>
                    {systemConfig?.companyPhone}
                  </a>
                  <span className='ml-2 text-xs italic'>(08h30 đến 22h00)</span>
                </p>
              </div>
            )}

            {systemConfig?.companyPhone2 && (
              <div>
                <p className='text-sm'>{systemConfig?.companyLabelPhone2}</p>
                <p className='mt-1 text-lg font-semibold'>
                  <a href={`tel:${systemConfig?.companyPhone2}`}>
                    {systemConfig?.companyPhone2}
                  </a>
                  <span className='ml-2 text-xs italic'>(08h30 đến 22h00)</span>
                </p>
              </div>
            )}
          </div>

          {(bottomMenu || []).map(e => (
            <div className='max-w-[25%] flex-4' key={e._id}>
              <h5 className='text-lg font-bold'>{getTranslate(e.name)}</h5>
              {e.children && e.children.length > 0 && (
                <ul className='mt-3 flex flex-col gap-1'>
                  {e.children.map(f => (
                    <li key={f._id} className='flex items-start'>
                      {f.type === 'link' ? (
                        <a href={f.url || ''}>{getTranslate(f.name)}</a>
                      ) : (
                        <a href={`/${f.slug + PageTypeSuffix.PAGE_CMS}`}>
                          {getTranslate(f.name)}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </section>

      <hr className='h-[1px] w-full border-none bg-link' />

      <section className='footerInfo bg-primary pb-11 pt-10 text-white'>
        <div className='container mx-auto flex items-center'>
          {systemConfig?.announcedMOIT && systemConfig?.companyVerify && (
            <Link
              href={systemConfig?.companyVerify || ''}
              title='Đã thông báo'
              target='blank'
              className='ml-auto mt-1 block'
            >
              <ImageOptimize
                width={170}
                height={58}
                src={systemConfig?.announcedMOIT || ''}
                className='ml-auto h-auto'
                alt='Đã thông báo'
              />
            </Link>
          )}

          <div className='flex grow flex-col items-center justify-center'>
            <p className='text-lg font-bold'>
              {getTranslate(systemConfig?.companyName)}
            </p>
            <p className='mt-2 text-center text-base'>
              <span>{t('businessRegisterCertificate')}: </span>
              <span>{getTranslate(systemConfig?.businessLicense)}</span>
              <br />
              <span>{t('address')}: </span>
              <span>{getTranslate(systemConfig?.companyAddress)}</span>
            </p>
          </div>
        </div>
      </section>
    </footer>
  )
}

export { Footer }
